module.exports = __webpack_public_path__ + "nr.a00df6c7.svg";